import type { TFunction } from 'i18next'
import type { DataTableColumn } from '@/components/ui/data-table-customized'
import type { InvoiceUpdate } from '@/modules/Invoice/types'
import Metadata from '@/components/Metadata'
import { formatDate } from '@/utils/function'

export const getInvoiceUpdateColumns = (
    t: TFunction
): DataTableColumn<InvoiceUpdate>[] => [
    {
        key: 'invoice_update_type',
        title: t('invoice_update_type'),
        width: 200,
        render: (value) => t(value) || '-',
    },
    {
        key: 'employee_name',
        title: t('employee_name'),
        width: 200,
    },
    {
        key: 'invoice_update_description',
        title: t('description'),
        width: 300,
    },
    {
        key: 'created_at',
        title: t('created_at'),
        width: 180,
        render: (value) => (
            <span className="text-muted-foreground">
                {formatDate(value) || '-'}
            </span>
        ),
    },
    {
        key: 'invoice_update_data' as any,
        title: 'Metadata',
        width: 200,
        render: (_, row) => <Metadata metadata={row?.invoice_update_data} />,
    },
]
